const region = process.env.REACT_APP_REGION || 'ru';

const positions = {
    assembler: {
        name: process.env.REACT_APP_POSITION_ASSEMBLER || 'Assembler',
        completionStatus: process.env.REACT_APP_STATUS_ASSEMBLER_COMPLETE || 'Assembled'
    },
    packer: {
        name: process.env.REACT_APP_POSITION_PACKER || 'Packer',
        completionStatus: process.env.REACT_APP_STATUS_PACKER_COMPLETE || 'Packed'
    },
    oilFiller: {
        name: process.env.REACT_APP_POSITION_OIL_FILLER || 'Oil Filler',
        completionStatus: process.env.REACT_APP_STATUS_OIL_FILLER_COMPLETE || 'Ready for Assembly'
    },
    receiver: {
        name: process.env.REACT_APP_POSITION_RECEIVER || 'Receiver',
        completionStatus: null
    }
};

const readyButtons = {};
Object.entries(positions).forEach(([key, pos]) => {
    const buttonText = process.env[`REACT_APP_BUTTON_${key.toUpperCase()}`];
    if (buttonText) {
        readyButtons[pos.name] = buttonText;
    }
});

if (Object.keys(readyButtons).length === 0) {
    readyButtons[positions.assembler.name] = 'ASSEMBLE';
    readyButtons[positions.packer.name] = 'PACK';
}

const statesMap = new Map();
Object.values(positions).forEach(pos => {
    if (pos.completionStatus) {
        statesMap.set(pos.name, pos.completionStatus);
    }
});

const config = {
    region,

    api: {
        url: process.env.REACT_APP_API_URL || '/api'
    },

    positions,

    ui: {
        readyButtons,
        states: statesMap
    },

    getCompletionStatus(positionName) {
        const pos = Object.values(positions).find(p => p.name === positionName);
        return pos?.completionStatus;
    },

    getButtonText(positionName) {
        return readyButtons[positionName];
    },

    getPositionKeyByName(positionName) {
        return Object.entries(positions).find(([key, pos]) => pos.name === positionName)?.[0];
    },

    get positionNames() {
        return Object.values(positions).map(p => p.name);
    }
};


export const READY_BUTTONS = readyButtons;
export const STATES = statesMap;

export default config;
